module.exports = __webpack_public_path__ + "img/shopping-cart.df341ba0.png";